import { Route, Switch } from "react-router-dom";
import Home from "./Home/index.jsx";
import Four04 from "./404/index.jsx";
import MyAssays from "./MyAssays/index.jsx";
import AssayDetail from "./AssayDetail/index.jsx";
import MutationDetection from "./AssayCreate/MutationDetection/MutationDetection.jsx";
import CopyNumberDetermination from "./AssayCreate/CopyNumberDetermination/CopyNumberDetermination.jsx";
import GenomeEditDetection from "./AssayCreate/GenomeEditing/GenomeEditDetection.jsx";
import { GEDHdrConfirmPage } from "./AssayCreate/GenomeEditing/GEDHdrConfirmPage.jsx";
import GeneExpression from "./AssayCreate/GeneExpression/GeneExpression.jsx";
import CellAndGeneTherapy from "./AssayCreate/CellAndGeneTherapy/CellAndGeneTherapy.jsx";
import FeaturedInfectiousDiseaseAssays from "./FeaturedContent/FeaturedInfectiousDiseaseAssays.jsx";
import FeaturedCellAndGeneTherapy from "./FeaturedContent/FeaturedCellAndGeneTherapy.jsx";
import FeaturedCentromericCopyNumberReferenceAssays from "./FeaturedContent/FeaturedCentromericCopyNumberReferenceAssays.jsx";
import { ConfirmSubmission } from "./AssayCreate/GenomeEditing/GenomeConfirmation/GenomeConfirmation.jsx";
import AssayBatchUpload from "./AssayBatchUpload/index.jsx";
import AssaySearch from "./AssaySearch/index.jsx";

import React from "react";
import { hot } from "react-hot-loader";
class App extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/digital-assays" component={Home} />
        <Route
          exact
          path="/digital-assays/assay-design-history"
          component={MyAssays}
        />
        <Route
          exact
          path="/digital-assays/assay-detail/:assayCommercialId"
          component={AssayDetail}
        />
        <Route
          exact
          path="/digital-assays/assays-create/mutation"
          component={MutationDetection}
        />
        <Route
          exact
          path="/digital-assays/assays-create/cnd"
          component={CopyNumberDetermination}
        />
        <Route
          exact
          path="/digital-assays/assays-create/genome"
          component={GenomeEditDetection}
        />
        <Route
          exact
          path="/digital-assays/assays-create/gene-expression"
          component={GeneExpression}
        />
        <Route
          exact
          path="/digital-assays/assays-create/cell-and-gene-therapy"
          component={CellAndGeneTherapy}
        />
        <Route
          exact
          path="/digital-assays/hdr-reference-assay"
          component={GEDHdrConfirmPage}
        />
        <Route
          exact
          path="/digital-assays/genome-confirmation"
          component={ConfirmSubmission} // route used for developing
        />
        <Route
          exact
          path="/digital-assays/assay-batch-upload"
          component={AssayBatchUpload}
        />
        <Route
          exact
          path="/digital-assays/search-results"
          component={AssaySearch}
        />
        <Route
          exact
          path="/digital-assays/featured-content/cell-and-gene-therapy"
          component={FeaturedCellAndGeneTherapy}
        />
        <Route
          exact
          path="/digital-assays/featured-content/centromeric-copy-number-reference-assays"
          component={FeaturedCentromericCopyNumberReferenceAssays}
        />
        <Route
          exact
          path="/digital-assays/featured-content/infectious-disease-assays"
          component={FeaturedInfectiousDiseaseAssays}
        />
        <Route component={Four04} />
      </Switch>
    );
  }
}

export default hot(module)(App);
